'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.services').config(translationsConfig);

    /* @ngInject */
    function translationsConfig($translateProvider) {

        $translateProvider.translations('el', {
            'scanner': {
                'name': 'name_el'
            },
            'gateway': {
                'name': 'name'
            },
            'device': {
                'name': 'name'
            },
            'category': {
                'name': 'name_el'
            },
            'foi': {
                'name': 'name_el'
            },
            'modality': {
                'name': 'name_el'
            },
            'granularity': {
                'name': 'name_el'
            },
            'compass': {
                'N': 'Β',
                'NNE': 'ΒΒΑ',
                'NE': 'ΒΑ',
                'ENE': 'ΑΒΑ',
                'E': 'Α',
                'ESE': 'ΑΝΑ',
                'SE': 'ΝΑ',
                'SSE': 'ΝΝΑ',
                'S': 'Ν',
                'SSW': 'ΝΝΔ',
                'SW': 'ΝΔ',
                'WSW': 'ΔΝΔ',
                'W': 'Δ',
                'WNW': 'ΔΝΔ',
                'NW': 'ΒΔ',
                'NNW': 'ΒΒΔ'
            }
        });
    }
})();